import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzNotificationService } from "ng-zorro-antd";
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextComponent implements OnInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() public formGroup: FormGroup;
    @Input() modalTitle: any;
    @Input() formData: any;
    formFieldConfig: any;
    fieldConfig: any;
    fieldCode: string = ''
    name: string;
    maxlength: string = '';
    hideTitle: boolean;
    isRefresh: boolean = false;
    value: string = '';
    tooltip: string;
    fieldDataInfo: any;
    taxCode = "";
    formCode = "";
    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef, private formBuilder: FormBuilder) { }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo = this.formFieldInfo;
            if (this.formFieldConfig && this.formFieldConfig.displayText) {
                this.name = this.formFieldConfig.displayText;
            }
            else if (this.fieldConfig && this.fieldConfig.displayText) {
                this.name = this.fieldConfig.displayText;
            }
            else {
                this.name = this.formFieldInfo.name;
            }

            if (this.fieldConfig && this.fieldConfig.maxlength) {
                this.maxlength = this.fieldConfig.maxlength
            }

            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.isRefresh = (this.formFieldConfig && this.formFieldConfig.osbconfig && this.formFieldConfig.osbconfig.isrefresh) ? this.formFieldConfig.osbconfig.isrefresh : false;
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.formCode = localStorage.getItem('FORM_CODE');
            this.taxCode = localStorage.getItem('TAXCODE');
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData() {
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + localStorage.getItem('TAXCODE') + '_' + this.fieldCode);
            if (storageVal) {
                this.value = storageVal;
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.value = this.formData[this.fieldCode];
            } else {
                this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            }
        }
        if (this.formFieldInfo.fieldCode.includes('SYS_CustomerIdentity')) {
            if (this.taxCode) {
                this.value = this.taxCode;
                if (localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.formFieldInfo.fieldCode)) {
                    if (localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.formFieldInfo.fieldCode) != this.taxCode) {
                        localStorage.setItem('TAXCODE', localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.formFieldInfo.fieldCode));
                        this.value = localStorage.getItem('TAXCODE');
                    }
                }
            }
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    keydownPattern(data: any) {
        // let regExp = new RegExp(this.fieldConfig.keydownPattern);
        // if (data.which == 8 || data.which == 13 || data.which == 46) {
        //     return;
        // }
        // if (!regExp.test(data.target.value)) {
        //     this.nzModalNotification.error("Error", this.name + " sai định dạng format");
        // }
    }

    onchangePattern(data: any) {
        let regExp = new RegExp(this.fieldConfig.keydownPattern)
        if (!regExp.test(data.target.value)) {
            this.nzModalNotification.error("Error", this.name + " sai định dạng format");
            return;
        }
    }

    clickSearchReloadButton() {
        // validatorOSBField
        if (this.formFieldInfo && this.formFieldConfig.osbconfig) { }
        // validatorAOField
        else if (this.formFieldInfo && this.formFieldConfig.apiconfig) { }
    }

    validatorAOField() {
        if (this.formFieldInfo && this.formFieldConfig) {
            return this.formFieldConfig.apiconfig ? true : false;
        }
        return false;
    }

    validatorOSBField() {
        if (this.formFieldInfo && this.formFieldConfig) {
            return this.formFieldConfig.osbconfig ? true : false;
        }

        return false;
    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode, this.value);
        if (this.formFieldInfo.fieldCode.includes('SYS_CustomerIdentity')) {
            localStorage.setItem('TAXCODE', localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.formFieldInfo.fieldCode));
        }
    }
}